import React from "react"
import styled from "styled-components"
import { ENV_NAME } from "src/lib/constants"

export const ENV_BANNER_HEIGHT = 28
export const IS_DEV_ENV = ENV_NAME === "development" || ENV_NAME === "local"

const BANNER_LABELS: Partial<Record<typeof ENV_NAME, string>> = {
  local: "🔧 LOCAL環境 🔧",
  development: "🔧 DEVELOPMENT環境 🔧",
}

const Component: React.FC<{ className?: string }> = ({ className }) => {
  if (!IS_DEV_ENV) return null

  return <div className={className}>{BANNER_LABELS[ENV_NAME]}</div>
}

export const EnvBanner = styled(Component)`
  height: ${ENV_BANNER_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff8c00;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.05em;
`
